import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20ambient%20cinematic%20abstract%20background%20with%20soft%20gradient%20tones%20of%20warm%20orange%20and%20golden%20light%20floating%20geometric%20shapes%20and%20particles%20creating%20depth%20elegant%20minimalist%20style%20suitable%20for%20video%20platform%20website%20hero%20section&width=1920&height=1080&seq=mv-hero-bg-01&orientation=landscape"
          alt="蘑菇视频网页版 - 在线视频平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-secondary-950/60 via-secondary-950/40 to-background-50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/10 mb-8">
          <i className="ri-sparkling-line text-accent-400 text-sm"></i>
          <span className="text-sm text-accent-200 font-medium whitespace-nowrap">无需下载 · 即开即看</span>
        </div>

        <h1 className="text-4xl md:text-6xl font-bold text-background-50 font-heading leading-tight mb-6">
          蘑菇视频<span className="text-accent-400">网页版</span>
        </h1>
        <p className="text-lg md:text-xl text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          免费在线视频观看入口，无需下载App即可直接在浏览器享受海量影视内容。
          支持电脑端和手机端，随时随地畅享流畅观影体验。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/dianshiju"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full text-base font-semibold text-secondary-950 bg-accent-500 hover:bg-accent-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-fill text-xl"></i>
            立即观看
          </Link>
          <Link
            to="/article/mogu-video-web-version-access-guide"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full text-base font-medium text-background-50 border border-background-50/30 hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-guide-line text-lg"></i>
            使用指南
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl mx-auto">
          {[
            { value: '20万+', label: '视频资源' },
            { value: '5000万+', label: '活跃用户' },
            { value: '8大类', label: '内容分类' },
            { value: '4K', label: '超清画质' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">{stat.value}</div>
              <div className="text-sm text-background-50/50 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}